export class OrganizationGroupAccess {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idpName",
            "baseName": "idpName",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupName",
            "baseName": "groupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "displayName",
            "baseName": "displayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "RoleSummary",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OrganizationGroupAccess.attributeTypeMap;
    }
    constructor() {
    }
}
